import { render, staticRenderFns } from "./RiskCard.vue?vue&type=template&id=f9867486&scoped=true"
import script from "./RiskCard.vue?vue&type=script&lang=js"
export * from "./RiskCard.vue?vue&type=script&lang=js"
import style0 from "./RiskCard.vue?vue&type=style&index=0&id=f9867486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9867486",
  null
  
)

export default component.exports